<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2024-09-10 17:40:36
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\views\platform\ICPS\basicConfig\components\genQrCode.vue
-->
<!--
 * @Description: 生成二维码
 * @Author: Roger Wei
 * @Date: 2021-11-30 16:14:29
 * @LastEditTime: 2021-11-30 17:39:31
 * @LastEditors: Roger Wei
 * @CopyRight: itence.com
 * @Reference: 
-->
<template>
  <div ref="qr-area"></div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  props: ["item", "width", "dataArr"],
  data() {
    return {
      cmUnit: 37.78,
      newDataArr: {},
      code: null,
    };
  },
  watch: {
    dataArr: {
      handler(val) {
        if (val) {
          if (this.code) {
            this.code.clear();
          }
          this.$set(this, "newDataArr", val);
          console.log(this.newDataArr);
          this.genQRCode();
        }
      },
      deep: true
    }
  },
  mounted() {
  this.$nextTick(() => {
    // 在DOM更新之后处理dataArr
    if (this.dataArr) {
      if (this.code) {
        this.code.clear();
      }
      this.$set(this, "newDataArr", this.dataArr);
      console.log(this.newDataArr);
      this.genQRCode();
    }
  });
},

  methods: {
    genQRCode() {
      let val = this.item.value;
      let isEmpty = !val;
      if (this.item.dataAttr.type === "custom") {
        val = "";
        if (this.newDataArr) {
          if (this.item.dataAttr.dataSource.length == 1) {
            val = this.newDataArr[this.item.dataAttr.dataSource[0]];
          } else {
            let newVal = this.item.dataAttr.dataSource.map(item => {
              // val = index == 0 ? item + ':' + this.newDataArr[item]  : val + ',' + item + ':' + this.newDataArr[item]
              let obj = {};
              obj[item] = this.newDataArr[item];
              return obj;
            });
            val = JSON.stringify(newVal);
          }
        } else {
          val = '模版设计'
        }
        isEmpty = this.item.dataAttr.dataSource.length === 0;
      }
      // 获取第一个元素
      let curDom = this.$refs["qr-area"];
      console.log(isEmpty)
      if (!isEmpty) {
        this.code = new QRCode(curDom, {
          text: val,
          width: this.item.attr.width * this.cmUnit,
          height: this.item.attr.width * this.cmUnit,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
        console.log(this.code);
      }
    },
  },
};
</script>